import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ChoiceChip({ label, selected, onSelect, multiple, disabled, leading, className, }) {
    const aria = multiple
        ? { 'aria-pressed': selected }
        : { role: 'radio', 'aria-checked': selected };
    return (_jsxs("button", { type: "button", className: `assist-chip ${selected ? 'assist-chip--selected' : ''} ${className ?? ''}`, disabled: disabled, onClick: onSelect, ...aria, children: [selected ? (_jsx("span", { className: "assist-chip__mark", "aria-hidden": "true", children: "\u2713" })) : null, leading, _jsx("span", { className: "assist-chip__label", children: label })] }));
}
export function ChoiceChipGroup({ label, children, className }) {
    return (_jsx("div", { className: `assist-chip-group ${className ?? ''}`, role: "radiogroup", "aria-label": label, children: children }));
}
//# sourceMappingURL=ChoiceChip.js.map